import { useState } from "react";
import { fetchApi } from "@/shared/lib/fetchApi";
import { customStorage } from "@/hooks/CustomLocalStorage";
import { DefaultTopAgency, MeResponse, MeState } from "../types";

export const DEFAULT_TOP_AGENCY: DefaultTopAgency = {
	name: "",
	id: 0,
};

// Function to handle fetching user profile
const useMe = () => {
	const [meState, setMeState] = useState<MeState>({
		loading: false,
		error: null,
		success: false,
		user: null,
		agency_id: 0,
		default_agency: DEFAULT_TOP_AGENCY,
		default_parent_agency: DEFAULT_TOP_AGENCY,
		agencyList: [],
		statusList: [],
	});

	// Fetch user data from the API
	const fetchMe = async (): Promise<void> => {
		console.log("Fetching user data..."); // Add this line
		// Prevent fetch if already loading
		if (meState.loading) return;

		setMeState(prevState => ({
			...prevState,
			loading: true,
			error: null,
			success: false,
		}));

		try {
			// const token = sessionStorage.getItem("access_token");

			const token = customStorage.getItem("access_token");

			if (!token) {
				throw new Error("No access token found.");
			}

			const response = await fetchApi.get<MeResponse>("auth/me");

			if (response.data.status === "OK" && response.data.status_code === 200) {
				const { user, agency_list, order_statuses, agency_id, default_agency, default_parent_agency } =
					response.data.data;

				// Map order_statuses to status_list for consistency
				const statusList = order_statuses;

				// Store user, agency list, and status list in localStorage
				customStorage.setItem(
					"me",
					JSON.stringify({
						agency_id,
						default_agency,
						default_parent_agency,
						user,
						agency_list,
						status_list: statusList,
					}),
				);
				setMeState({
					loading: false,
					error: null,
					success: true,
					user,
					agency_id,
					default_agency,
					default_parent_agency,
					agencyList: agency_list,
					statusList,
				});
			} else {
				setMeState({
					loading: false,
					error: response.data.message || "Unexpected error occurred.",
					success: false,
					user: null,
					agency_id: 0,
					default_agency: DEFAULT_TOP_AGENCY,
					default_parent_agency: DEFAULT_TOP_AGENCY,
					agencyList: [],
					statusList: [],
				});
			}
		} catch (error) {
			// Error handling
			setMeState({
				loading: false,
				error: error instanceof Error ? error.message : "Something went wrong",
				success: false,
				user: null,
				agency_id: 0,
				default_agency: DEFAULT_TOP_AGENCY,
				default_parent_agency: DEFAULT_TOP_AGENCY,
				agencyList: [],
				statusList: [],
			});
		}
	};

	// Return state and fetch function
	return { fetchMe, meState };
};

export default useMe;
